import { useEffect } from 'react';

/**
 * Hook to show a warning when user tries to leave the page during critical operations.
 *
 * @param enabled - Whether the warning should be active
 * @param message - Optional custom message (note: most browsers ignore custom messages)
 */
export function useExitWarning(enabled: boolean, message?: string) {
  useEffect(() => {
    if (!enabled) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Note: Most modern browsers ignore custom messages and show their own
      e.returnValue = message || 'Sei sicuro di voler abbandonare? I dati non salvati potrebbero andare persi.';
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [enabled, message]);
}
